<template>
  <div>
    <FormLabel label="絞り込み" />

    <div class="d-flex align-items-center">
      <Dropdown
        v-model="selectedOrganizationId"
        option-label="name"
        option-value="id"
        :options="organizations"
        style="min-width: 150px"
        class="me-3 radius"
      >
        <template #option="slotProps">
          <div class="d-flex align-items-center">
            <div>{{ slotProps.option.name }}</div>
            <i v-if="slotProps.option.isMember" class="pi pi-user ms-2"></i>
          </div>
        </template>
      </Dropdown>
      <Dropdown
        v-model="selectedYear"
        :option-label="(y) => (y === 'all' ? 'すべて' : y + '年')"
        :options="trainingsYears"
        style="min-width: 150px"
        class="me-3 radius"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Label as FormLabel } from "/@/vue/components/Atom";
import { OrganizationClient } from "/@/types";
import Dropdown from "primevue/dropdown";

const selectedOrganizationId = defineModel<number>("selectedOrganizationId");
const selectedYear = defineModel<string>("selectedYear");

defineProps<{
  organizations: OrganizationClient[];
  trainingsYears: string[];
}>();
</script>

<style scoped lang="scss"></style>
